/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const Pagination = ({
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  pages,
}) => {
  return (
    <>
      <div className="pools_table__pagination mt-6 mt-md-8">
        <nav>
          <ul className="d-flex align-items-center gap-3 gap-md-5">
            <li className={` px-3 py-2 br1 rounded-5 d-center ${currentPage === 1 ? "page-active" : ""}`} onClick={() => setCurrentPage(1)}>
              <a
                href="#"
                className="page-link"                
                disabled={currentPage === 1 ? true : false}
              >
                {"<<"}
              </a>
            </li>
            {currentPage - 2 > 0 ? (
              <li className=" px-5 py-3 br1 rounded-5 d-center" onClick={() => setCurrentPage((prev) => prev - 2)}>
                <span
                  className="p1-color fs-five"                  
                >
                  {currentPage - 2}
                </span>
              </li>
            ) : (
              ""
            )}
            {currentPage - 1 > 0 ? (
              <li className=" px-5 py-3 br1 rounded-5 d-center" onClick={() => setCurrentPage((prev) => prev - 1)}>
                <span
                  className="p1-color fs-five"
                >
                  {currentPage - 1}
                </span>
              </li>
            ) : (
              ""
            )}
            <li className=" px-5 py-3 br1 rounded-5 d-center page-active">
              <span className="p1-color fs-five" disabled={true}>
                {currentPage}
              </span>
            </li>
            {currentPage + 1 <= pages ? (
              <li className=" px-5 py-3 br1 rounded-5 d-center" onClick={() => setCurrentPage((prev) => prev + 1)}>
                <span
                  className="p1-color fs-five"                  
                >
                  {currentPage + 1}
                </span>
              </li>
            ) : (
              ""
            )}
            {currentPage + 2 <= pages ? (
              <li className=" px-5 py-3 br1 rounded-5 d-center" onClick={() => setCurrentPage((prev) => prev + 2)}>
                <span
                  className="p1-color fs-five"                  
                >
                  {currentPage + 2}
                </span>
              </li>
            ) : (
              ""
            )}
            <li
              className={` px-3 py-2 br1 rounded-5 d-center ${currentPage === pages ? "page-active" : ""}`}
              onClick={() => setCurrentPage(pages)}
            >
              <a
                href="#"
                className="page-link"                
                disabled={currentPage === pages ? true : false}
              >
                {">>"}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Pagination;
